import React from "react";
import { useNavigate } from "react-router-dom";

const Profile = ({ onCancel }) => {
  const navigate = useNavigate();
  const onClickHandler = () => {
    navigate("/profile");
    onCancel();
  };
  return (
    <div
      className="flex text-xs font-medium pt-2 pb-1 pl-8"
      onClick={onClickHandler}
    >
      <img className="w-3 h-4 pt-1 mr-3 " src="/images/User.png" alt="" />
      My Profile
    </div>
  );
};
export default Profile;
